export default __webpack_public_path__ + "static/media/pwlogo.3f641589.jpeg";